import React from 'react';


import PlayerCard from './PlayerCard';
import GolfRoundTable from './GolfRoundTable';
import GolfScoreTable from './GolfScoreTable';

const GolfRounds = ({ data }) => {
  return (
    <>
      <PlayerCard title="Score">
        <GolfScoreTable data={data} />
      </PlayerCard>
      {data?.rounds?.R1 && (
        <PlayerCard title="Round 1">
          <GolfRoundTable data={data?.rounds?.R1} name={data?.nm} fid={data?.fid} />
        </PlayerCard>
      )}
      {data?.rounds?.R2 && (
        <PlayerCard title="Round 2">
          <GolfRoundTable data={data?.rounds?.R2} name={data?.nm} fid={data?.fid} />
        </PlayerCard>
      )}
      {data?.rounds?.R3 && (
        <PlayerCard title="Round 3">
          <GolfRoundTable data={data?.rounds?.R3} name={data?.nm} fid={data?.fid} />
        </PlayerCard>
      )}
      {data?.rounds?.R4 && (
        <PlayerCard title="Round 4">
          <GolfRoundTable data={data?.rounds?.R4} name={data?.nm} fid={data?.fid} />
        </PlayerCard>
      )}
    </>
  );
};

export default GolfRounds;
